if (!customElements.get("nmn-product-card")) {
  customElements.define(
    "nmn-product-card",
    class extends HTMLElement {
      async connectedCallback() {
        this.connectionId = (this.connectionId || 0) + 1;
        const connectionId = this.connectionId;
        const button = this.querySelector("[data-product-open]");
        const fallback = this.querySelector("[data-product-fallback]");
        if (!button || !fallback) return;
        const opener = button.closest("modal-opener");
        if (!opener) return;
        button.hidden = true;
        opener.hidden = true;
        fallback.hidden = false;

        await customElements.whenDefined("quick-add-modal");
        if (!this.isConnected || connectionId !== this.connectionId) return;

        // Dawn moves dialogs to the body; retain ownership for editor replacements.
        this.modal ||= document.getElementById(button.getAttribute("aria-controls"));
        if (!this.modal) return;
        if (!this.modal.isConnected) document.body.appendChild(this.modal);
        button.hidden = false;
        opener.hidden = false;
        fallback.hidden = true;
      }

      disconnectedCallback() {
        this.connectionId = (this.connectionId || 0) + 1;
        const button = this.querySelector("[data-product-open]");
        const modal = this.modal || (button && document.getElementById(button.getAttribute("aria-controls")));
        if (!modal) return;
        if (modal.hasAttribute("open")) modal.hide(true);
        modal.remove();
      }
    },
  );
}
